/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
import GoodsList from './components/GoodsList';
import SearchInput from './components/SearchInput';
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import '@/store/mutation_types';
import NoDataImg from '@/resources/images/mall/noOrder.png';
export default {
  data: function data() {
    return {
      goodsList: [],
      noData: false,
      hasKeyowrds: false,
      keywords: '',
      goodsCategoryId: '',
      NoDataImg: NoDataImg
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var goodsCategoryName = to.query.goodsCategoryName;
    console.log(goodsCategoryName);

    if (goodsCategoryName) {
      window.document.title = goodsCategoryName;
    }

    next();
  },
  created: function created() {
    var keywords = this.$route.query.keywords;
    this.hasKeyowrds = keywords ? true : false;
    this.keywords = keywords;
    this.goodsCategoryId = this.$route.query.goodsCategoryId;
  },
  components: {
    GoodsList: GoodsList,
    SearchInput: SearchInput
  },
  computed: _objectSpread(_objectSpread({}, mapState({})), {}, {
    direction: function direction() {
      if (this.hasKeyowrds) {
        return 'row';
      } else {
        return 'column';
      }
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions([])), {}, {
    search: function search(keywords) {
      this.keywords = keywords;
    }
  })
};